function initMap(){}


function initialize() {

    var latlng = new google.maps.LatLng(35.66920122650523,139.70735803993136);
    var myOptions = {
        zoom: 17,
        center: latlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map(document.getElementById('map_canvas'), myOptions)

    var icon = new google.maps.MarkerImage('https://kimari.net/hs/blurred/ico_lopan.png',
        new google.maps.Size(50,63),
        new google.maps.Point(0,0),
        new google.maps.Point(25,63)
    );

    var shadow = new google.maps.MarkerImage('https://kimari.net/hs/blurred/ico_lopan.png',
        new google.maps.Size(50,63),
        new google.maps.Point(0,63),
        new google.maps.Point(25,63)
    );

    var markerOptions = {
        position: latlng,
        map: map,
        icon: icon,
        shadow: shadow,
        title: 'blurred'
    };

    var styleOptions =[
        {
            "featureType": "administrative",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": "-100"
                }
            ]
        },
        {
            "featureType": "administrative.province",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "lightness": 65
                },
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "lightness": "50"
                },
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": "-100"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "all",
            "stylers": [
                {
                    "lightness": "30"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "all",
            "stylers": [
                {
                    "lightness": "40"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "hue": "#ffff00"
                },
                {
                    "lightness": -25
                },
                {
                    "saturation": -97
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels",
            "stylers": [
                {
                    "lightness": -25
                },
                {
                    "saturation": -100
                }
            ]
        }
    ];




    // var styleOptions = [{
    //     featureType: 'all',
    //     elementType: 'labels',
    //     stylers: [{ visibility: 'off' }]
    // }
    //     ,{
    //         featureType: 'all',
    //         elementType: 'geometry',
    //         stylers: [{ hue: '#00' }, { saturation: '-100' }, { gamma: '0.5' }]
    //     }];

    var lopanType = new google.maps.StyledMapType(styleOptions);
    map.mapTypes.set('noText', lopanType);
    map.setMapTypeId('noText');

    var marker = new google.maps.Marker(markerOptions);
}
